<template>
  <div class="col right" style="margin-bottom: 5px">
    <v-popover placement="bottom" @hide="hideAllModals">
      <div class="col status monitorStatus" :title="$t('views.dashboard.selector.monitorstatus')">
        <div v-if="monitorStatusId === 1" class="info-icons-div">
          <i class="material-icons switch-info-icon" :style="{'color' : monitorStatusColor }">check</i>
        </div>
        <div v-else-if="monitorStatusId === 2" class="info-icons-div">
          <img class="switch-info-icon" src="../../assets/switch/Warning icon.svg">
        </div>
        <div v-else-if="monitorStatusId === 3" class="info-icons-div">
          <img class="switch-info-icon" src="../../assets/switch/Alarm icon.svg">
        </div>
        <span class="body2" :style="{'color' : monitorStatusColor }">{{ monitorstatusDescription }}</span>
      </div>
      <div class="col status operationalStatus" :title="$t('views.dashboard.selector.operationalstatus')">
        <div v-if="operationModeId === 5" class="info-icons-div">
          <i class="material-icons switch-info-icon status-maintenance">build</i>
        </div>
        <div v-else-if="operationModeId === 1" class="info-icons-div">
          <i class="material-icons switch-info-icon status-normal">check</i>
        </div>
        <div v-else></div>
        <span class="body1" v-bind:class="{ 'status-maintenance': operationModeId === 5 }">{{ operationalStatusDescription }}</span><br />
      </div>
      <div class="col status lastMaintenance" :title="$t('views.switch.lastmaintenancedate')">
        <div class="info-icons-div">
          <i class="material-icons switch-info-icon" style="color: dodgerblue">build</i>
        </div>
        <span class="body1">{{ lastMaintenanceDateTime }}</span>
      </div>
      <div class="col status">
        <i class="material-icons">
          keyboard_arrow_down
        </i>
      </div>
      <template slot="popover">
        <div class="card-panel" style="width: 450px;">
          <SwitchInfo :rail-object="railObject" :child-objects="childObjects" ref="switchInfo" />
        </div>
      </template>
    </v-popover>
  </div>
</template>
<script>
import moment from 'moment'
import SwitchInfo from './SwitchInfoPopOver'

export default {
  name: 'StatusBar',
  components: {SwitchInfo},
  props: {
    railObject: {
      required: false,
      type: Object
    },
    childObjects: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {}
  },
  methods: {
    hideAllModals () {
      this.$refs.switchInfo.hideAllModals()
    }
  },
  computed: {
    monitorstatusDescription: function () {
      if (this.railObject) {
        switch (this.railObject.MonitorStatusId) {
          case 1:
            return this.$t('ok')
          case 2:
            return this.$t('warning')
          case 3:
            return this.$t('error')
          default:
            return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    monitorStatusColor: function () {
      if (this.railObject) {
        switch (this.railObject.MonitorStatusId) {
          case 1:
            return '#1DB85F'
          case 2:
            return '#FFA842'
          case 3:
            return '#C91414'
          default:
            return 'grey'
        }
      } else {
        return 'grey'
      }
    },
    operationModeId () {
      if (this.railObject) {
        return this.railObject.OperationModeId
      } else {
        return 0
      }
    },
    operationalStatusDescription: function () {
      if (this.railObject) {
        switch (this.railObject.OperationModeId) {
          case 1:
            return this.$t('operational')
          case 5:
            return this.$t('maintenance')
          default:
            return this.$t('operational')
        }
      } else {
        return this.$t('unknown')
      }
    },
    statusMeasurementDateTime: function () {
      if (this.railObject) {
        if (this.railObject.StatusMeasurementDateTime) {
          const result = moment(this.railObject.StatusMeasurementDateTime).format('YYYY-MM-DD HH:mm:ss')
          return result
        } else {
          return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    monitorStatusId () {
      if (this.railObject) {
        return this.railObject.MonitorStatusId
      } else {
        return 0
      }
    },
    lastMaintenanceDateTime: function () {
      if (this.railObject) {
        if (this.railObject.LastMaintenanceDateTime) {
          return moment(this.railObject.LastMaintenanceDateTime).format('YYYY-MM-DD')
        } else {
          return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    latitude: function () {
      if (this.railObject) {
        if (this.railObject.Latitude) {
          return parseFloat(this.railObject.Latitude)
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    longtitude: function () {
      if (this.railObject) {
        if (this.railObject.Longtitude) {
          return parseFloat(this.railObject.Longtitude)
        } else {
          return 0
        }
      } else {
        return 0
      }
    }
  }
}
</script>
<style scoped>

  /* #switch-tabs {
    margin-left: -10px;
    right: 0;
    width: 100%;
  }*/
  .card-panel {
    margin: 0px !important;
  }

  .status-normal {
    color: #1DB85F;
  }

  .status-maintenance {
    color: #0D47A1;
  }

  .body1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }

  .info-icons-div {
    display: inline-block;
    padding-right: 5px;
  }

  .switch-info-icon {
    vertical-align: bottom;
  }

  .status {
    height: 34px;
    border-radius: 25px;
    background-color: lightgray;
    padding: 5px 15px;
    margin: 0px 5px;
    cursor: pointer;
  }

  select {
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/StatusIcons.vue